var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpTouchmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e0e2e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 13.44l-3.27-1.62a5.44 5.44 0 002.14-4.32 5.55 5.55 0 10-8.07 4.89v3.26l-1.86-.39h-.42a2 2 0 00-1.43.59L4 17.22l5.14 5.09a2.36 2.36 0 001.66.69h6.36a2 2 0 002-1.67l.84-4.71a3 3 0 00-1.68-3.18zM18 16.29L17.16 21H10.8a.37.37 0 01-.24-.1l-3.71-3.68 4.29.89V7.5a.5.5 0 01.58-.4.51.51 0 01.4.4v6h1.77l3.49 1.73a1 1 0 01.62 1.06zM11.64 4a3.52 3.52 0 00-3.53 3.5 3.4 3.4 0 001 2.44V7.5a2.52 2.52 0 015 0v2.44a3.4 3.4 0 001-2.44A3.52 3.52 0 0011.64 4z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpTouchmin);
export default __webpack_public_path__ + "static/media/help-touch.min.b5bb982a93b9371a2c1850bcd0c053d5.svg";
export { ForwardRef as ReactComponent };